"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkField = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const link_field_styles_1 = require("./link-field.styles");
const icons_1 = require("../../../../../icons");
const LinkField = (_a) => {
    var { href, target } = _a, props = __rest(_a, ["href", "target"]);
    return (react_1.default.createElement(ui_components_1.Link, { href: href, target: target, underline: 'none' }, react_1.default.createElement(link_field_styles_1.StyledIconButton, Object.assign({}, props), react_1.default.createElement(icons_1.LinkIcon, null))));
};
exports.LinkField = LinkField;
